import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/planti/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ '../views/index')
  },
  {
    path: '/planti/anuncio',
    name: 'Anuncio',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/anuncio.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  // eslint-disable-next-line no-unused-vars
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: routes
})


// router.beforeEach((async (to, from, next) => {
//   const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
//   if (requiresAuth && !auth.currentUser) {
//     next('/login')
//   }else{
//     if (to.matched.length > 0) {
//       next()
//     } else {
//       if (!auth.currentUser){
//         next('/login')
//       }else{
//         console.log("Page 404")
//         next()
//       }
//     }
//   }
// }));

export default router
